export const mockData = {
  personal: {
    name: "Michael Tallada",
    title: "Full-Stack Developer | ML Enthusiast | Senior SEO | Data Analyst",
    location: "General Trias, Cavite",
    phone: "0909 400 3145",
    email: "Tallada88@gmail.com",
    github: "https://github.com/KuyaMecky",
    linkedin: "https://www.linkedin.com/in/michael-tallada/",
    portfolio: "https://mecky-portfolio.vercel.app/",
    gitlab: "https://gitlab.com/KuyaMecky",
    summary: "Versatile and performance-driven IT professional with over 5 years of experience in full-stack web development, SEO/SEM, machine learning, and data analytics. Specialized in technical SEO, scalable systems architecture, and optimized user-centric interfaces. As a Senior SEO Specialist, consistently delivered 150%+ organic traffic growth, achieved top SERP rankings, and drove business-critical improvements through precision keyword targeting and strategic content optimization."
  },
  
  skills: {
    "Web Development": [
      "ReactJS", "NextJS", "PHP", "JavaScript", "Vue", "Vite", "WordPress", "Laravel", "Django", "Bootstrap", "ASP.NET", "VB", "Xamarin", "Cordova"
    ],
    "Software Development": [
      "Java", "C++", "C#", "Kotlin", "Python", "Android Studio", "Machine Learning", "Deep Learning", "Data Structures", "Algorithms"
    ],
    "API & Backend": [
      "Node.js", "RESTful APIs", "MySQL", "Postman", "Curl", "Sanity", "JWT Authentication"
    ],
    "DevOps & Cloud": [
      "Docker", "Nginx", "VPS (AApanel)", "Git", "GitHub", "GitLab", "CI/CD Pipelines", "Cloudflare", "Azure DevOps"
    ],
    "SEO & Analytics": [
      "Google Analytics", "Search Console", "Ahrefs", "Semrush", "Dev Console", "AdSense", "Bing Webmaster Tool", "Keyword Research", "Technical SEO"
    ],
    "Design & Multimedia": [
      "Adobe Photoshop", "Adobe Premiere", "Sony Vegas", "Blender", "SketchUp", "AutoCAD", "3DMax"
    ]
  },

  experience: [
    {
      title: "Search Engine Optimization Specialist",
      company: "xFuture",
      location: "France",
      period: "Apr 2025 – July 2025",
      description: "Orchestrating global SEO strategies that increased keyword rankings by 40% YoY. Performing advanced competitor analysis, CTR optimization, and site audits."
    },
    {
      title: "Senior SEO Specialist",
      company: "Vertex Inc.",
      location: "Makati, Philippines",
      period: "Feb 2025 – May 2025",
      description: "Leading cross-functional SEO/UX projects to drive measurable improvements in CRO and SERP visibility. Introduced structured data and schema implementation across product pages."
    },
    {
      title: "SEO Team Leader",
      company: "New Oriental Club",
      location: "China",
      period: "March 2024 – Feb 2025",
      description: "Executed advanced content strategies in line with Google's evolving algorithms. Boosted domain authority by 25+ through ethical backlink outreach campaigns."
    },
    {
      title: "Full Stack Developer",
      company: "Wbridge Manpower Corp",
      location: "Philippines",
      period: "Jan 2024 – Feb 2025",
      description: "Developed responsive SPAs using ReactJS, NextJS, Sass, and Vite with performance-first architecture. Engineered custom WordPress themes and integrated 3rd-party APIs, improving load time by 30%."
    },
    {
      title: "SEO Team Lead",
      company: "Wbridge Manpower Corp",
      location: "Philippines",
      period: "Jun 2024 – Feb 2025",
      description: "Directed a team of 6 SEO professionals to double site traffic and improve bounce rate by 20%. Executed backlink strategies, technical audits, and search intent-focused content marketing."
    }
  ],

  projects: [
    {
      id: 1,
      name: "LetoPea-V2.0",
      description: "Filipino Sign Language recognition system using LSTM neural networks and MediaPipe. Real-time sign prediction with text-to-speech conversion.",
      tech: ["Python", "LSTM", "MediaPipe", "TensorFlow", "OpenCV"],
      github: "https://github.com/KuyaMecky/LetoPea-V2.0",
      live: null,
      image: "/api/placeholder/400/250"
    },
    {
      id: 2,
      name: "Attendance Management System V2",
      description: "Web-based platform for tracking student/employee attendance with role-based access and real-time dashboards.",
      tech: ["Laravel", "MySQL", "PHP", "JavaScript", "Bootstrap"],
      github: "https://github.com/KuyaMecky/attendance-system",
      live: null,
      image: "/api/placeholder/400/250"
    },
    {
      id: 3,
      name: "E-commerce Website",
      description: "Full-featured e-commerce PWA with shopping cart, admin dashboard, coupon system, and social media integration.",
      tech: ["Laravel 10", "MySQL", "Vue.js", "PWA", "Stripe"],
      github: "https://github.com/KuyaMecky/ecommerce-laravel",
      live: null,
      image: "/api/placeholder/400/250"
    },
    {
      id: 4,
      name: "SEO Analytics Tools",
      description: "Built keyword ranking simulator, backlink checker, and SEO health dashboards using Python and Node.js. Integrated Google/Bing APIs for automated reporting.",
      tech: ["Python", "Node.js", "Google APIs", "MongoDB", "React"],
      github: "https://github.com/KuyaMecky/seo-tools",
      live: null,
      image: "/api/placeholder/400/250"
    }
  ],

  certifications: [
    "Google Project Management (2023)",
    "CompTIA Security+ SY0-501 (2023)",
    "Microsoft Certified: Azure Developer Associate (2021)",
    "Google Analytics Individual Qualification (2020)",
    "NC III Java & .NET Programming (2018)"
  ],

  education: [
    {
      degree: "Bachelor of Science in Information Technology",
      institution: "Cavite State University, Silang Campus",
      period: "2019 – 2023"
    },
    {
      degree: "ICT-MAWD (Mobile App & Web Dev)",
      institution: "STI College Dasmariñas, Senior High School",
      period: "2016 – 2018"
    }
  ]
};